import { ComingSoon } from '../shared/ComingSoon';

// The client's own page: their loan officer's card, then the sections their loan officer turned on
export function ClientHome() {
  return (
    <ComingSoon title="Your home loan">
      Sign-in is coming next: a one-time code by text or email, no password to remember.
    </ComingSoon>
  );
}
